import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { WithApp } from 'contexts/appContext';
import { wsGetAll, wsFindBy } from 'services/WService';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import moment from 'moment';
import MultiComplete from 'components/Tvendo/Common/MultiComplete';

export default WithApp(function ModalCuotaProvider(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;
  const [supervisorData, setSupervisorData] = useState([]);
  const [supervisorZonaData, setSupervisorZonaData] = useState([]);
  // const incentivos = props.incentivos;

  const [dataImport, setDataImport] = useState({});
  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState({
    ...customerPortfolioB,
    type: customerPortfolioB.type || 'N', // Por defecto N
  });
  const [sellers, setSellers] = useState([]);
  const [selectedSellers, setSelectedSellers] = useState([]);
  const [bureaus, setBureaus] = useState([]);
  
  function handleChange(field, value) {
    setDataChanging(prev => ({
      ...prev,
      [field]: value,
    }));
  }
  async function listSellers() {
    const response = await wsFindBy('sale/seller-zone', {
      base_zone_id: props.softy_supervisors.base_zone_id,
      base_business_partner_id: 10,
      base_bureau_id: dataChanging.base_bureau_id,
      base_canal_id: dataChanging.base_canal_id,
      deleted_at: 'null',
      state: 'A'
    });
  
    if (response.success) {
      setSellers(response.data);
    }
  }

  async function listBureaus(){
    const response = await wsFindBy('base/bureau',{
      base_zone_id: props.softy_supervisors.base_zone_id,
      deleted_at: 'null',
      state: 'A'});
      if (response.success) {
        setBureaus(response.data);
      }
  }

  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);

  useEffect(() => {
    if (bPartnerSelect?.id) {
      setDataImport({});
    }
  }, [bPartnerSelect]);

  useEffect(() => {
    if (customerPortfolioB.open) {
      if (!customerPortfolioB.id)
        setDataChanging(customerPortfolioB);
    }
  }, [customerPortfolioB.open]);

  useEffect(() => {
    if (props.softy_supervisors) {
      setSupervisorData([props.softy_supervisors]);
      setDataChanging(prev => ({
        ...prev,
        softy_supervisor_id: props.softy_supervisors.id,
      }));
    }
  }, [props.softy_supervisors]);

  useEffect(() => {
    if (props.softy_supervisors) {
      const zoneId = props.softy_supervisors.base_zone_id;
      setSupervisorZonaData([props.softy_supervisors]);
      setDataChanging(prev => ({
        ...prev,
        base_zone_id: zoneId,
      }));
      if (zoneId && zoneId.length > 0) {
        listBureaus();
      }
    }
  }, [props.softy_supervisors]);

  useEffect(() => {
    if (dataChanging.base_bureau_id && dataChanging.base_canal_id) {
      setSellers([]);
      setSelectedSellers([]);
      listSellers();
    }
  }, [dataChanging.base_bureau_id, dataChanging.base_canal_id]);

  console.log(dataChanging);

  return (
    <>
      <Modal
        title={`Nuevo vendedor para supervisor`}
        model={{ open: cuota.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        softy_supervisors={props.softy_supervisors}
        arrDataResponse
        entity='sale/softy-supervisor-detalle'
        dataForce={{
          softy_supervisor_id: dataChanging.softy_supervisor_id,
          base_seller_ids: selectedSellers.map(s => s.id),
        }}
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="periodo"
          margin="normal"
          defaultValue={moment(cuota.valueSearch?.Periodo).format('YYYY-MM') || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <Autocomplete
          disableClearable
          options={supervisorData}
          getOptionLabel={(item) => `${item.supervisor_name}`}
          renderInput={(params) => (
            <TextField {...params} label="Supervisor" margin="normal" required />
          )}
          onChange={(e, item) => handleChange('softy_supervisor_id', item?.id)}
          value={supervisorData.find(incentivo => incentivo.id === dataChanging.softy_supervisor_id) || null}
          disabled
          required
        />
        <Autocomplete
          disableClearable
          options={supervisorZonaData}
          getOptionLabel={(item) => `${item.zonas}`}
          renderInput={(params) => (
            <TextField {...params} label="Zona" margin="normal" required />
          )}
          onChange={(e, item) => handleChange('base_zone_id', item?.base_zone_id)}
          value={supervisorData.find(incentivo => incentivo.base_zone_id === dataChanging.base_zone_id) || null}
          disabled
          required
        />
        <Autocomplete
          disableClearable
          options={bureaus}
          getOptionLabel={(item) => `${item.description}`}
          renderInput={(params) => (
            <TextField {...params} label="Mesa" margin="normal" required />
          )}
          onChange={(e, item) => handleChange('base_bureau_id', item?.id)}
          value={bureaus.find(mesa => mesa.id === dataChanging.base_bureau_id) || null}
          required
        />
        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>Canal</InputLabel>
          <Select
            required
            value={dataChanging.base_canal_id || ''}
            inputProps={{
              name: 'base_canal_id',
              onChange: (e) => handleChange('base_canal_id', e.target.value),  
            }}
          >
            <MenuItem value="1">Minorista</MenuItem>
            <MenuItem value="2">Mayorista</MenuItem>
          </Select>
        </FormControl>
        <MultiComplete
          label="Vendedores"
          selectAll
          limitTags={1}
          textField="SlpName"
          options={sellers}
          selected={selectedSellers}
          setSelected={setSelectedSellers}
        />
      </Modal>
    </>
  );
});
